import * as yup from 'yup';
import { VehicleExtraType } from '@carvia/ros-client-types';

export const customExtrasSchema = yup.object({
  customBookedExtras: yup
    .array(
      yup.object({
        description: yup.string().required(),
        price: yup.number().required(),
        customVehicleExtraType: yup.string().oneOf(Object.keys(VehicleExtraType)).nullable(),
        value: yup.number().when('customVehicleExtraType', {
          is: (val: VehicleExtraType) =>
            val === VehicleExtraType.ADDITIONAL_DRIVER ||
            val === VehicleExtraType.DEDUCTIBLE ||
            val === VehicleExtraType.EXTRA_KM,
          then: (schema) => schema.required(),
          otherwise: (schema) => schema.notRequired(),
        }),
        id: yup.string().optional(),
        photoFileKeys: yup.array().of(yup.string().required()).optional(),
        photoFileUrls: yup.array().of(yup.string().required()).optional(),
        isAdditional: yup.boolean().optional(),
        couponCode: yup.string().optional(),
      }),
    )
    .notRequired(),
});

export const customTotalBasePriceSchema = yup.object({
  customTotalBasePrice: yup.number().nullable(),
});

export const periodQuoteFormSchema = customExtrasSchema
  .concat(customTotalBasePriceSchema)
  .concat(yup.object({ customInclusiveKm: yup.number().nullable() }));
